export const RESOURCES = {
  articles: {
    label: "Articles",
    endpoint: "/articles",
    columns: [
      { key: "title", label: "Title" },
      { key: "category", label: "Category" },
      { key: "published", label: "Live", type: "bool" },
    ],
    fields: [
      { name: "title", label: "Title", type: "text", required: true },
      { name: "category", label: "Category", type: "select", options: ["Wellness", "GAUGE Your Life", "Holistic Recovery", "Stewardship", "Community", "Human Enhancement"] },
      { name: "author", label: "Author", type: "text" },
      { name: "cover_image", label: "Cover Image", type: "image" },
      { name: "excerpt", label: "Excerpt", type: "textarea" },
      { name: "body", label: "Body", type: "richtext", placeholder: "Write your article — add headings, images and videos…" },
      { name: "tags", label: "Tags", type: "tags" },
      { name: "published", label: "Published (visible on site)", type: "switch" },
    ],
    defaults: { title: "", category: "Wellness", author: 'Chris "Yellow Owl" Albaugh', cover_image: "", excerpt: "", body: "", tags: [], published: true },
  },
  testimonials: {
    label: "Testimonials",
    endpoint: "/testimonials",
    columns: [
      { key: "name", label: "Name" },
      { key: "role", label: "Role" },
      { key: "featured", label: "Featured", type: "bool" },
    ],
    fields: [
      { name: "name", label: "Name", type: "text", required: true },
      { name: "role", label: "Role", type: "text" },
      { name: "quote", label: "Quote", type: "textarea", rows: 4 },
      { name: "avatar", label: "Avatar", type: "image" },
      { name: "rating", label: "Rating (1-5)", type: "number" },
      { name: "featured", label: "Featured (spotlight)", type: "switch" },
      { name: "published", label: "Published", type: "switch" },
    ],
    defaults: { name: "", role: "", quote: "", avatar: "", rating: 5, featured: false, published: true },
  },
  events: {
    label: "Events",
    endpoint: "/events",
    columns: [
      { key: "title", label: "Title" },
      { key: "date", label: "Date" },
      { key: "category", label: "Category" },
      { key: "location_id", label: "Assigned location", type: "location" },
    ],
    fields: [
      { name: "title", label: "Title", type: "text", required: true },
      { name: "location_id", label: "Assigned location", type: "location_assign", required: true },
      { name: "category", label: "Category / Type", type: "text", placeholder: "e.g. Circle, Sound Healing, Breathwork, Retreat — type any category; new ones become filters automatically" },
      { name: "facilitator", label: "Facilitator", type: "text" },
      { name: "location", label: "Location / Resource", type: "select", options: ["Main Room", "Float Room", "Massage Room", "Sauna Room", "Outdoor Ceremony Space", "Retreat Land", "Online Zoom Room"] },
      { name: "date", label: "Date (first / main day)", type: "date", required: true },
      { name: "start_time", label: "Start Time", type: "time" },
      { name: "end_time", label: "End Time", type: "time" },
      { name: "days", label: "Multi-day schedule (optional)", type: "event_days" },
      { name: "description", label: "Description", type: "richtext", placeholder: "Describe the event — add headings, images and video…" },
      { name: "image", label: "Event photo (square)", type: "image", crop: "square" },
      { name: "price", label: "Base price ($, if no tiers)", type: "number" },
      { name: "deposit_pct", label: "Member deposit % (0 = default 25%)", type: "number" },
      { name: "capacity", label: "Capacity (if no tiers)", type: "number" },
      { name: "tiers", label: "Ticket tiers", type: "tiers" },
      { name: "meal_options", label: "Meal add-ons", type: "priced_options" },
      { name: "lodging_options", label: "Lodging add-ons", type: "priced_options" },
      { name: "waitlist_enabled", label: "Enable waitlist when full", type: "switch" },
      { name: "member_included", label: "Included for Members", type: "switch" },
      { name: "recurrence", label: "Repeat", type: "recurrence" },
      { name: "is_virtual", label: "Online / virtual event", type: "switch" },
      { name: "timezone", label: "Timezone (for virtual events)", type: "text", placeholder: "e.g. America/New_York — shown to your global audience" },
      { name: "published", label: "Published", type: "switch" },
    ],
    defaults: { title: "", location_id: "", category: "Circle", facilitator: "", location: "Main Room", date: "", start_time: "18:00", end_time: "20:00", days: [], description: "", image: "", price: 0, capacity: 20, tiers: [], meal_options: [], lodging_options: [], waitlist_enabled: true, member_included: false, recurrence: null, is_virtual: false, published: true },
  },
  gauge: {
    label: "GAUGE",
    endpoint: "/gauge",
    columns: [
      { key: "letter", label: "Letter" },
      { key: "pillar", label: "Pillar" },
      { key: "order", label: "Order" },
    ],
    fields: [
      { name: "letter", label: "Letter (G/A/U/G/E)", type: "text", required: true },
      { name: "pillar", label: "Pillar", type: "text", required: true },
      { name: "tagline", label: "Tagline", type: "text" },
      { name: "description", label: "Description", type: "richtext" },
      { name: "reflection_prompt", label: "Reflection Prompt", type: "textarea" },
      { name: "order", label: "Order", type: "number" },
      { name: "published", label: "Published", type: "switch" },
    ],
    defaults: { letter: "", pillar: "", tagline: "", description: "", reflection_prompt: "", order: 0, published: true },
  },
  services: {
    label: "Services",
    endpoint: "/services",
    noCreate: true,
    readOnly: true,
    roomWarning: true,
    columns: [
      { key: "title", label: "Title" },
      { key: "location", label: "Center" },
      { key: "price", label: "Price" },
      { key: "approval_status", label: "Status" },
    ],
    fields: [
      { name: "title", label: "Title", type: "text", required: true },
      { name: "category", label: "Category", type: "text", placeholder: "e.g. Float Therapy, Reiki, Sound Healing — type any category that best fits" },
      { name: "facilitator", label: "Facilitator / Enhancer", type: "text" },
      { name: "location", label: "Location", type: "text" },
      { name: "room", label: "Center room (links the service to a room for conflict-blocking)", type: "relation", optionsEndpoint: "/rooms", optionValue: "key", optionLabel: "name", emptyLabel: "— No room —" },
      { name: "duration_min", label: "Duration (min)", type: "number" },
      { name: "buffer_before_min", label: "Buffer before (min)", type: "number" },
      { name: "buffer_after_min", label: "Buffer / cleaning after (min)", type: "number" },
      { name: "price", label: "Price ($)", type: "number" },
      { name: "member_discount_pct", label: "Member Discount (%)", type: "number" },
      { name: "deposit_pct", label: "Member deposit % (0 = default 25%)", type: "number" },
      { name: "by_appointment", label: "By appointment only (member picks a practitioner + available slot)", type: "switch" },
      { name: "enhancer_required", label: "Requires a specific enhancer", type: "switch", help: "Off = center-operated, room-based service (float, sauna, steam, ionic foot bath…): availability follows center hours + the room calendar only — no practitioner selection or availability checks." },
      { name: "bookable_anytime", label: "Bookable anytime (self-book any open slot; e.g. float therapy)", type: "switch", help: "Skips practitioner-availability windows. Members can book any open time within center hours, limited by the capacity below." },
      { name: "anytime_capacity", label: "Anytime capacity (concurrent slots, e.g. # of float tanks)", type: "number" },
      { name: "delivery_method", label: "Delivery method (virtual link type)", type: "select", options: ["in_person", "zoom", "google_meet", "manual"] },
      { name: "practitioner_ids", label: "Practitioners (who can deliver this)", type: "multiselect", optionsEndpoint: "/admin/enhancers-options", optionLabel: "name" },
      { name: "image", label: "Image (square)", type: "image", crop: "square" },
      { name: "short_description", label: "Short Description", type: "textarea" },
      { name: "description", label: "Full Description", type: "richtext", placeholder: "Describe this service — add headings, images and video…" },
      { name: "requires_agreement", label: "Requires signed waiver", type: "switch" },
      { name: "is_center_service", label: "Center Service Library (official shared service)", type: "switch" },
      { name: "service_type", label: "Booking type", type: "select", options: ["", "foundation", "shared", "signature"], help: "foundation = Center service with a default provider (no guest choice unless enabled below); shared = guests choose a qualified provider (e.g. Reiki); signature = the Enhancer's own offering. Blank = auto (center→shared, else signature)." },
      { name: "allow_provider_choice", label: "Foundation: let guests choose their provider", type: "switch" },
      { name: "default_providers", label: "Default provider per location (foundation)", type: "default_providers" },
      { name: "booking_policy", label: "Cancellation policy for this offering (optional)", type: "service_policy", help: "Overrides the center / global cancellation terms for this service only. Use for offerings that need stricter cancellation terms." },
      { name: "reporting_category", label: "Reporting category", type: "select", options: ["", "Float Therapy", "Reiki", "Energy Healing", "Massage", "Sound Healing", "Breathwork", "Ionic Foot Bath", "Steam Sauna", "Red Light Therapy", "Recovery Mentorship", "Coaching", "Classes", "Circles", "Workshops", "Body-Based Practice"] },
      { name: "focus_areas", label: "Areas of support (symptoms/needs this helps with)", type: "multiselect", options: ["Stress", "Anxiety", "Grief", "Trauma recovery", "Addiction recovery", "Sleep", "Fatigue", "Pain", "Relationships", "Emotional regulation", "Spiritual development", "Personal growth", "Mobility", "Relaxation", "Nervous system regulation", "Focus & clarity", "Confidence", "Creativity"] },
      { name: "approval_status", label: "Approval (pending/approved/rejected)", type: "select", options: ["approved", "pending", "rejected"] },
      { name: "published", label: "Published", type: "switch" },
    ],
    defaults: { title: "", category: "Wellness", facilitator: "", location: "Main Room", room: "", duration_min: 60, buffer_before_min: 0, buffer_after_min: 0, price: 0, member_discount_pct: 0, image: "", short_description: "", description: "", requires_agreement: false, focus_areas: [], service_type: "", allow_provider_choice: false, enhancer_required: true, default_providers: {}, booking_policy: {}, approval_status: "approved", published: true },
  },
  rooms: {
    label: "Rooms",
    endpoint: "/rooms",
    columns: [
      { key: "name", label: "Name" },
      { key: "key", label: "Key" },
      { key: "capacity", label: "Capacity" },
      { key: "active", label: "Active", type: "bool" },
    ],
    fields: [
      { name: "name", label: "Name", type: "text", required: true },
      { name: "key", label: "Key (auto — center-prefixed from name, e.g. newport_wellness_room)", type: "text" },
      { name: "location_id", label: "Center", type: "relation", optionsEndpoint: "/admin/locations", optionLabel: "name", required: true, emptyLabel: "— Select a center —" },
      { name: "description", label: "Description", type: "textarea" },
      { name: "capacity", label: "Capacity", type: "number" },
      { name: "space_type", label: "Space type", type: "select", options: ["wellness_center", "retreat_space"] },
      { name: "requires_approval", label: "Requires admin approval to reserve", type: "switch" },
      { name: "active", label: "Active (bookable)", type: "switch" },
    ],
    defaults: { name: "", key: "", location_id: "", description: "", capacity: 0, space_type: "wellness_center", requires_approval: false, active: true },
  },
  products: {
    label: "Products",
    endpoint: "/products",
    noCreate: true,
    columns: [
      { key: "title", label: "Title" },
      { key: "type", label: "Type" },
      { key: "price", label: "Price" },
      { key: "approval_status", label: "Status" },
    ],
    fields: [
      { name: "title", label: "Title", type: "text", required: true },
      { name: "category", label: "Category", type: "text", placeholder: "e.g. Wellness Tools, Courses, Art — type any category that best fits" },
      { name: "type", label: "Type", type: "select", options: ["physical", "digital"] },
      { name: "price", label: "Price ($)", type: "number" },
      { name: "member_discount_pct", label: "Member Discount (%)", type: "number" },
      { name: "deposit_pct", label: "Member deposit % (0 = default 25%)", type: "number" },
      { name: "shipping_price", label: "Shipping price ($, physical)", type: "number" },
      { name: "location_id", label: "Fulfilled by center (optional — leave blank for enhancer/EYW)", type: "relation", optionsEndpoint: "/admin/locations", optionLabel: "name", emptyLabel: "— Enhancer / EYW central —" },
      { name: "stock", label: "Stock (physical)", type: "number" },
      { name: "track_stock", label: "Track stock", type: "switch" },
      { name: "reorder_threshold", label: "Low-stock alert threshold (0 = off)", type: "number" },
      { name: "digital_url", label: "Digital download URL", type: "text" },
      { name: "sku", label: "SKU", type: "text" },
      { name: "barcode", label: "Barcode / UPC", type: "text" },
      { name: "cost", label: "Unit cost ($, for margin)", type: "number" },
      { name: "variants", label: "Variants (size / scent / tier)", type: "variants" },
      { name: "image", label: "Image (square)", type: "image", crop: "square" },
      { name: "short_description", label: "Short Description", type: "textarea" },
      { name: "description", label: "Full Description", type: "richtext", placeholder: "Describe this product — add headings, images and video…" },
      { name: "approval_status", label: "Approval", type: "select", options: ["approved", "pending", "rejected"] },
      { name: "published", label: "Published", type: "switch" },
    ],
    defaults: { title: "", category: "Wellness Tools", type: "physical", price: 0, member_discount_pct: 0, shipping_price: 0, location_id: "", stock: 0, track_stock: false, reorder_threshold: 0, digital_url: "", sku: "", barcode: "", cost: 0, variants: [], image: "", short_description: "", description: "", approval_status: "approved", published: true },
  },
  packages: {
    label: "Packages",
    endpoint: "/packages",
    noCreate: true,
    columns: [
      { key: "name", label: "Name" },
      { key: "sessions", label: "Sessions" },
      { key: "price", label: "Price" },
      { key: "active", label: "Active", type: "bool" },
    ],
    fields: [
      { name: "name", label: "Name", type: "text", required: true },
      { name: "description", label: "Description", type: "richtext" },
      { name: "service_category", label: "Service scope (blank = any)", type: "text" },
      { name: "sessions", label: "Number of sessions", type: "number" },
      { name: "price", label: "Price ($)", type: "number" },
      { name: "eligible_service_ids", label: "Eligible offerings (sessions can be redeemed for these)", type: "multiselect", optionsEndpoint: "/services", optionLabel: "title" },
      { name: "session_value", label: "Session value ($) — base wellness value; enhancement upcharge = service price − this", type: "number" },
      { name: "member_discount_pct", label: "Member Discount (%)", type: "number" },
      { name: "validity_days", label: "Valid for (days)", type: "number" },
      { name: "active", label: "Active", type: "switch" },
    ],
    defaults: { name: "", description: "", service_category: "", sessions: 5, price: 0, eligible_service_ids: [], session_value: 75, member_discount_pct: 0, validity_days: 365, active: true },
  },
  agreements: {
    label: "Agreements",
    endpoint: "/agreements",
    columns: [
      { key: "title", label: "Title" },
      { key: "type", label: "Type" },
      { key: "version", label: "Ver" },
      { key: "active", label: "Active", type: "bool" },
    ],
    fields: [
      { name: "title", label: "Title", type: "text", required: true },
      { name: "type", label: "Type", type: "select", options: ["waiver", "member", "pma", "ministry", "location", "service", "terms", "privacy", "media"] },
      { name: "required_for", label: "Required For (booking/event/membership)", type: "tags" },
      { name: "location_ids", label: "Required for bookings at these centers", type: "multiselect", optionsEndpoint: "/admin/locations", optionLabel: "name" },
      { name: "service_types", label: "Required for these session types", type: "multiselect", options: ["foundation", "shared", "signature"] },
      { name: "content", label: "Content", type: "richtext", media: false },
      { name: "active", label: "Active", type: "switch" },
    ],
    defaults: { title: "", type: "waiver", required_for: [], location_ids: [], service_types: [], content: "", active: true },
  },
  groups: {
    label: "Groups",
    endpoint: "/groups",
    columns: [
      { key: "name", label: "Name" },
      { key: "access", label: "Access" },
      { key: "member_count", label: "Members" },
      { key: "published", label: "Live", type: "bool" },
    ],
    fields: [
      { name: "name", label: "Name", type: "text", required: true },
      { name: "slug", label: "Slug (auto if blank)", type: "text" },
      { name: "description", label: "Description", type: "richtext", media: false },
      { name: "icon", label: "Icon (lucide name, e.g. Users)", type: "text" },
      { name: "image", label: "Cover image", type: "image" },
      { name: "access", label: "Access", type: "select", options: ["open", "tier_gated", "request"] },
      { name: "allowed_roles", label: "Allowed roles (tier_gated only)", type: "tags" },
      { name: "published", label: "Published", type: "switch" },
    ],
    defaults: { name: "", slug: "", description: "", icon: "Users", image: "", access: "open", allowed_roles: [], published: true },
  },
  stewardship: {
    label: "Stewardship",
    endpoint: "/stewardship",
    columns: [
      { key: "title", label: "Title" },
      { key: "status", label: "Status" },
      { key: "needs_volunteers", label: "Volunteers", type: "bool" },
    ],
    fields: [
      { name: "title", label: "Title", type: "text", required: true },
      { name: "description", label: "Description", type: "richtext", placeholder: "Describe this project — add headings, images and video…" },
      { name: "goal", label: "Goal", type: "number" },
      { name: "current", label: "Current progress", type: "number" },
      { name: "unit", label: "Unit (% / volunteers / $)", type: "text" },
      { name: "image", label: "Image", type: "image" },
      { name: "needs_volunteers", label: "Needs volunteers", type: "switch" },
      { name: "status", label: "Status", type: "select", options: ["active", "complete", "paused"] },
      { name: "published", label: "Published", type: "switch" },
    ],
    defaults: { title: "", description: "", goal: 100, current: 0, unit: "%", image: "", needs_volunteers: false, status: "active", published: true },
  },
  media: {
    label: "Media",
    endpoint: "/media",
    columns: [
      { key: "title", label: "Title" },
      { key: "media_type", label: "Type" },
      { key: "visibility", label: "Visibility" },
      { key: "published", label: "Published", type: "bool" },
    ],
    fields: [
      { name: "title", label: "Title", type: "text", required: true },
      { name: "media_type", label: "Type", type: "select", options: ["podcast", "vlog", "interview", "workshop", "audio", "video"] },
      { name: "description", label: "Description", type: "richtext", placeholder: "Describe this media — add headings, images and video…" },
      { name: "featured_image", label: "Featured image", type: "image" },
      { name: "video_embed_url", label: "Video embed URL (YouTube/Vimeo/Spotify)", type: "text" },
      { name: "audio_url", label: "Audio file URL (upload then paste, or external)", type: "text" },
      { name: "host", label: "Host / author", type: "text" },
      { name: "episode_number", label: "Episode number", type: "number" },
      { name: "visibility", label: "Visibility", type: "select", options: ["public", "discovery", "community", "enhancer", "private"] },
      { name: "published", label: "Published", type: "switch" },
    ],
    defaults: { title: "", media_type: "podcast", description: "", featured_image: "", video_embed_url: "", audio_url: "", host: "", episode_number: null, visibility: "public", published: true },
  },
};
